<template>
  <vs-popup class="popup-select-978"
    title="공정분류표"
    :active.sync="showPopup">

    <vs-tabs v-model="currTab">
      <vs-tab label="공정별 환경시설 분류" />
      <vs-tab label="전체 환경시설 " />
    </vs-tabs>

    <page978 v-if="currTab === 0" ref="page978" mode="popup" @close="showPopup = false;" @select="onSelect"/>
    <page978 v-else mode="popup" all @close="showPopup = false;" @select="onSelect"/>
  </vs-popup>
</template>

<script>
import page978 from "@/views/boards/single-page/978/Page.vue";
export default {
  components: {
    page978
  },
  props: {
    value: Boolean,
  },
  watch: {

  },
  computed: {
    showPopup: {
      get () {
        return this.value;
      },
      set (val) {
        this.$emit('input', val);
      },
    }
  },
  data () {
    return {
      currTab: 0,
    }
  },
  methods: {
    onSelect (model) {
      this.$emit('select', model);
      this.showPopup = false;
    }
  }
}
</script>

<style scoped>

</style>

<style>
.popup-select-978 > .vs-popup {
  width: 1200px !important;
}
</style>
